import { toast } from '@/lib/hooks/useToast.ts'
import i18n from '@/i18n.ts'
import { ToastActionElement } from '@/components/ui/Toast.tsx'

export default function showSuccessToast(
  description?: string,
  title?: string,
  successButton?: ToastActionElement,
) {
  toast({
    action: successButton,
    title: title ?? i18n.t('common.success'),
    description: description ?? i18n.t('common.dataSaved'),
  })
}
